'use client'

import { type FC, type PropsWithChildren } from 'react'
import { Configure } from 'react-instantsearch'
import { InstantSearchNext } from 'react-instantsearch-nextjs'

import {
  useAlgoliaConfigContext,
  useAlgoliaUserToken,
  useSearchClient,
} from '../../../algolia'
import { useExpaContext } from '../../../expa'
import { PRODUCT_SEARCH_HITS_PER_PAGE } from '../../config/productSearchAlgoliaConstants'

type ProductSearchSellerPromotionAlgoliaSearchProps = PropsWithChildren<{
  promotionId: number
  sellerId?: string
}>

export const ProductSearchSellerPromotionAlgoliaSearch: FC<
  ProductSearchSellerPromotionAlgoliaSearchProps
> = ({ children, promotionId, sellerId }) => {
  const { productsAlgoliaIndex, topSellerProductsAlgoliaIndex } =
    useAlgoliaConfigContext()
  const searchClient = useSearchClient()
  const ruleContext = useExpaContext() ?? 'direct'
  const algoliaUserToken = useAlgoliaUserToken()
  const promotionFilter = `best_offer.seller_promotion.promotionId=${promotionId}`
  const filters = sellerId
    ? `best_offer.seller.id:${JSON.stringify(sellerId)} AND ${promotionFilter}`
    : promotionFilter

  return (
    <InstantSearchNext
      future={{
        preserveSharedStateOnUnmount: true,
      }}
      indexName={productsAlgoliaIndex}
      initialUiState={{
        [productsAlgoliaIndex]: {
          sortBy: topSellerProductsAlgoliaIndex,
        },
      }}
      searchClient={searchClient}
    >
      <Configure
        analytics
        clickAnalytics
        distinct={0}
        filters={filters}
        hitsPerPage={PRODUCT_SEARCH_HITS_PER_PAGE}
        ruleContexts={[ruleContext]}
        userToken={algoliaUserToken}
      />
      {children}
    </InstantSearchNext>
  )
}
